import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: "app-niveles-educativos-formularios",
  templateUrl: "./formulario.component.html"
})
export class NivelesEducativosFormulariosComponent implements OnInit{
  dato: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.dato = this.fb.group({
      niveles_educativos_formularios: this.fb.group({
        alumno: this.fb.array([]),
        preinscripcion: this.fb.array([]),
      })
    });

    document.getElementById("catalogos").click();
  }

  agregar_niveles(niveles){
    setTimeout(() => {
      if (this.dato.controls.niveles_educativos_formularios["controls"]["alumno"]["controls"].length == 0) {
        niveles.forEach(element => {
          this.dato.controls.niveles_educativos_formularios["controls"]["alumno"]["controls"].push(this.fb.group({
            id: [""],
            niveles_educativos_id: [element.id, [Validators.required]],
            niveles_educativos: [element],
            formularios_id: ["", [Validators.required]],
            formularios: ['']
          }));

          this.dato.controls.niveles_educativos_formularios["controls"]["preinscripcion"]["controls"].push(this.fb.group({
            id: [""],
            niveles_educativos_id: [element.id, [Validators.required]],
            niveles_educativos: [element],
            formularios_id: ["", [Validators.required]],
            formularios: ['']
          }))
        });
      }
    }, 200);
  }
}
